export default {
  notifications: [],
  notificationsTopics: ["TICKET_INMEDIATE_ATTENTION"],
  unsubscribeGetAllNotifications: null,
};
